import React, { useState } from 'react';

const defaultValue = {
  usuarios: [],
  usuarioAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  modal: '',
};

export const UsuarioContext = React.createContext({});

export const UsuarioProvider = (props) => {
  return (
    <UsuarioContext.Provider
      value={{
        usuarios: useState(defaultValue.usuarios),
        usuarioAtual: useState(defaultValue.usuarioAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
      }}
    >
      {props.children}
    </UsuarioContext.Provider>
  );
};

export const UsuarioConsumer = UsuarioContext.Consumer;
